import { useQuery } from '@tanstack/react-query';
import { productsService, type ProductQueryParams } from '../services/products.service';

export function useProducts(params: ProductQueryParams = {}, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['products', params],
    queryFn: () => productsService.list(params),
    placeholderData: (prev) => prev,
    enabled: options.enabled ?? true,
  });
}
